<div>
  <div class="signature-preview-container"></div>
</div>
